export default {"src":"/_next/static/media/router.97732eb7.svg","height":101,"width":101};